import { render } from "./FormAccountSelector.vue?vue&type=template&id=1cbe0524&scoped=true&ts=true"
import script from "./FormAccountSelector.vue?vue&type=script&lang=ts"
export * from "./FormAccountSelector.vue?vue&type=script&lang=ts"

import "./FormAccountSelector.vue?vue&type=style&index=0&id=1cbe0524&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbe0524"]])

export default __exports__